import { sva } from '@agapi/ui/panda/css';

export const iconCardStyles = sva({
  slots: ['icon', 'content', 'container'],
  base: {
    container: {
      display: 'flex',
      gap: '4',
      alignItems: 'center'
    },
    icon: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexShrink: '0',
      w: 'items.xl',
      h: 'items.xl',
      p: '3',
      mb: '2',
      rounded: 'full',
      backgroundColor: 'surface.primary.subdued.background',
      color: 'brand.primary'
    },
    content: {
      display: 'flex',
      width: '100%',
      flexDirection: 'column',
      gap: '4',
      fontSize: 'sm',
    }
  },
  variants: {
    direction: {
      vertical: {
        container: {
          flexDirection: 'row'
        },
        content: {
          alignItems: 'center',
          textAlign: 'center'
        }
      },
      horizontal: {
        container: {
          flexDirection: 'row'
        },
        content: {
          alignItems: 'flex-start',
          textAlign: 'left'
        }
      }
    }
  },
  defaultVariants: {
    direction: 'vertical'
  }
});